import { combineReducers } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { GUEST_PERMISSIONS } from "@loanbossinc/component-library";
import { mapPermissions } from "store/state/auth";
import { createSelector } from "reselect";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , makeIsLoadingReducer
  , multipleObjectReturn
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const QUOTE_MODULE_GET_DEAL = generateDefaultActions("QUOTE_MODULE_GET_DEAL");
export const quoteModuleGetDeal = payload => makePayload(QUOTE_MODULE_GET_DEAL.value, payload);
function* quoteModuleGetDealSaga(payload) {
  const url = `/getDealName/${payload.dealId}`;
  yield requestSaga(QUOTE_MODULE_GET_DEAL, url, "GET");
}

export const QUOTE_MODULE_GET_QUOTES = generateDefaultActions("QUOTE_MODULE_GET_QUOTES");
export const quoteModuleGetQuotes = payload => makePayload(QUOTE_MODULE_GET_QUOTES.value, payload);
function* quoteModuleGetQuotesSaga(payload) {
  const url = `/quotes/deal/${payload.dealId}/quotes`;
  yield requestSaga(QUOTE_MODULE_GET_QUOTES, url, "GET");
}

export const QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES = generateDefaultActions("QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES");
export const quoteModuleGetSupplementalQuotes = payload => makePayload(QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES.value, payload);
function* quoteModuleGetSupplementalQuotesSaga(payload) {
  const url = `/quotes/deal/${payload.dealId}/supplemental`;
  yield requestSaga(QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES, url, "GET");
}

export const QUOTE_MODULE_GET_MODIFYING_QUOTES = generateDefaultActions("QUOTE_MODULE_GET_MODIFYING_QUOTES");
export const quoteModuleGetModifyingQuotes = payload => makePayload(QUOTE_MODULE_GET_MODIFYING_QUOTES.value, payload);
function* quoteModuleGetModifyingQuotesSaga(payload) {
  const url = `/quotes/deal/${payload.dealId}/modifying`;
  yield requestSaga(QUOTE_MODULE_GET_MODIFYING_QUOTES, url, "GET");
}

// REDUCER

const initialState = {
  deal: null,
  quotes: [],
  mapModulePermissions: {
    canOnlySeeEmptyStateModule: true
  }
};

function quoteModuleReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case QUOTE_MODULE_GET_DEAL.success:
      return defaultReturn(state, payload.data, "deal");

    case QUOTE_MODULE_GET_QUOTES.success:
      return multipleObjectReturn(state, ["quotes", "guestPermission"], [payload.data, payload.guestPermission]);

    case QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES.success:
      return multipleObjectReturn(state, ["quotes", "guestPermission"], [payload.data, payload.guestPermission]);

    case QUOTE_MODULE_GET_MODIFYING_QUOTES.success:
      return multipleObjectReturn(state, ["quotes", "guestPermission"], [payload.data, payload.guestPermission]);

    case QUOTE_MODULE_GET_QUOTES.error:
    case QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES.error:
    case QUOTE_MODULE_GET_MODIFYING_QUOTES.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    default:
      return state;
  }
}

export default combineReducers({
  quoteModuleReducer,
  quoteModuleQuoteLoading: makeIsLoadingReducer(QUOTE_MODULE_GET_QUOTES)
});

// SAGA

export function* quoteModuleSaga() {
  yield takeLatest(QUOTE_MODULE_GET_DEAL.value, quoteModuleGetDealSaga);
  yield takeLatest(QUOTE_MODULE_GET_QUOTES.value, quoteModuleGetQuotesSaga);
  yield takeLatest(QUOTE_MODULE_GET_SUPPLEMENTAL_QUOTES.value, quoteModuleGetSupplementalQuotesSaga);
  yield takeLatest(QUOTE_MODULE_GET_MODIFYING_QUOTES.value, quoteModuleGetModifyingQuotesSaga);
}

const canViewModule = auth => auth && !auth.isGuest;

const canOnlySeeEmptyStateModule = auth => auth &&
  auth.isGuest &&
  auth.guestPermissions &&
  (auth.guestPermissions.pipelinePermissionId === GUEST_PERMISSIONS.VIEW || auth.guestPermissions.pipelinePermissionId === GUEST_PERMISSIONS.EDIT);

// SELECTORS
export const mapModulePermissions = createSelector(mapPermissions, auth => ({
  canOnlySeeEmptyStateModule: canOnlySeeEmptyStateModule(auth),
  canViewModule: canViewModule(auth)
}));
